/* eslint-disable camelcase */
/* eslint-disable no-console */
import React, { useState } from 'react';
import axios from 'axios';

const LikeHeart = ({ initLikeState, heartFilledPath, heartOutlinePath, id, type }) => {
  const [liked, setLiked] = useState(initLikeState);

  const instance = axios.create({
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  });

  const handleHeartIcon = liked ? heartFilledPath : heartOutlinePath;

  const createLike = () => {
    instance.post('/likes', {
      likeable_id: id,
      likeable_type: type
    })
    .then(() => {
      setLiked(true);
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const destroyLike = () => {
    instance.delete('/likes', {
      likeable_id: id,
      likeable_type: type
    })
    .then(() => {
      setLiked(false);
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const handleClick = () => liked ? destroyLike() : createLike();

  return (
    <div className="like-heart ml-10" style={{ cursor: 'pointer' }} onClick={handleClick} >
      <img src={handleHeartIcon} alt="like-heart" />
   </div>
  );
};


export default LikeHeart;
